// @flow
import api, { buildHeaders } from 'common/services/api';
import Estimation from 'common/modules/proposition/domain/estimation';
import Opportunity from 'common/modules/proposition/domain/opportunity';
import AgeRangeReachesAPIHelper from 'common/helpers/AgeRangeReachesAPIHelper';
import { EstimationProgress } from '../domain/estimationProgress';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';
import DateRange from '../../../../common/domain/DateRange';

const ISO_DATE = 'YYYY-MM-DD';

export async function estimate(token: string, callSign: string, toEstimate: Opportunity[], centralMarket: ?CentralMarket,
                               metricsDateRange: ?DateRange): Promise<EstimationProgress> {
  const payload = {
    centralMarket: centralMarket && centralMarket.reference,
    from: metricsDateRange && metricsDateRange.from.format(ISO_DATE),
    to: metricsDateRange && metricsDateRange.to.format(ISO_DATE),
    salesRows: toEstimate.map(opportunity => ({
      ...opportunity.toJSON(),
      cost: opportunity.costPerOpportunities,
    })),
  };

  const { data } = await api.post(`/${callSign}/sales/estimations/async`, payload, { headers: buildHeaders(token) });

  return new EstimationProgress({ step: data.state, callSign, reference: data.reference, data: undefined });
}

export async function fetch(token: string, callSign: string, reference: string): Promise<Estimation> {
  const { data } = await api.get(`/${callSign}/sales/estimations/${reference}`, {}, { headers: buildHeaders(token) });

  const json = {
    ...data,
    ageGroup: AgeRangeReachesAPIHelper.flatToJson(data.ageGroup, data.ageGroupMetadata),
  };

  return Estimation.parse(json);
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/services/SalesEstimationApi.js